module.exports = __webpack_public_path__ + "static/img/rz(1).833b4634.png";